module.exports = __webpack_public_path__ + "2b173e96c2c81703a2f16911b69965e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/global-nav/mazda-logo.svg
// module id = 1257
// module chunks = 0 1